import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import React from "react";
import { ColorPallet } from "../../utils/colorPallet";
import NoDataMessage from "../common/NoDataMessage";
import { CustomPagination } from "./customPagination";
interface IProps {
  headerData: any;
  rowData: any;
  isFourHeader?: any;
  removeBorder?: any;
  page?: number;
  rowsPerPage?: number;
  totalCount?: number;
  onPageChange?: any;
  onRowsPerPageChange?: any;
  hasAccess?: any;
  isPagination?: any;
  payHistory?: any;
}
const AllTable = ({
  rowData,
  headerData,
  isFourHeader,
  removeBorder,
  page,
  rowsPerPage,
  totalCount,
  onPageChange,
  onRowsPerPageChange,
  hasAccess,
  isPagination,
  payHistory,
}: IProps) => {
  return (
    <>
      <TableContainer
        component={Paper}
        sx={{
          maxHeight: {
            xs:  300,
            sm:  400,
            md:  350,
            lg: payHistory ? 250 : 600,
            xl: payHistory ? 250 : 700,
          },
          "@media (min-width:820px) and (max-width:900px)": {
            maxHeight: 550,
          },
          "@media (min-width:1023px) and (max-width:1050px)": {
            maxHeight: 210,
          },
          "@media (min-width:1200px) and (max-width:1280px)": {
            maxHeight: 400,
          },
        }}
      >
        <Table
          aria-label="simple table"
          sx={{ border: `1px solid ${ColorPallet.borderColor}`}}
          stickyHeader
        >
          <TableHead sx={{ backgroundColor: ColorPallet.tableHeaderColor }}>
            <TableRow
              sx={{
                borderTop: `1px solid ${ColorPallet.borderColor}`,
                borderBottom: `1px solid ${ColorPallet.borderColor}`,
                borderLeft: `1px solid ${ColorPallet.borderColor}`,
                borderRight: `1px solid ${ColorPallet.borderColor}`,
                width: isFourHeader ? "50%" : "auto",
              }}
            >
              {headerData?.map((headerItem: any, index: any) => (
                <TableCell
                  key={index}
                  sx={{
                    borderTop: `1px solid ${ColorPallet.borderColor}`,
                    borderBottom: `1px solid ${ColorPallet.borderColor}`,
                    borderLeft:
                      index === 0
                        ? `1px solid ${ColorPallet.borderColor}`
                        : removeBorder
                        ? "none"
                        : `1px solid ${ColorPallet.borderColor}`, // Left border only for first column
                    borderRight:
                      index === headerData.length - 1
                        ? `1px solid ${ColorPallet.borderColor}`
                        : removeBorder
                        ? "none"
                        : `1px solid ${ColorPallet.borderColor}`, // Right border only for last column
                    width: isFourHeader ? "50%" : "auto",
                    padding: "0px 15px",
                  }}
                >
                  {headerItem.title}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rowData?.length === 0 && hasAccess ? (
              <TableRow>
                <TableCell colSpan={headerData.length} align="center">
                  <NoDataMessage />
                </TableCell>
              </TableRow>
            ) : (
              rowData?.map((row: any, rowIndex: any) => (
                <TableRow key={rowIndex}>
                  {headerData.map((headerItem: any, colIndex: number) => {
                    const isTillToday =
                      row["Date"]?.trim().toLowerCase() === "till today";
                    const isInvoiceNoCell =
                      headerItem.title === "Invoice No." &&
                      row["Invoice No."]?.trim() === "Invoice(s)";

                    // Apply red color if it's a Till Today row, but not the Invoice(s) cell
                    const shouldApplyRed = isTillToday && !isInvoiceNoCell;

                    return (
                      <TableCell
                        key={colIndex}
                        sx={{
                          fontWeight: shouldApplyRed ? "600" : "normal",
                          borderTop: `1px solid ${ColorPallet.borderColor}`,
                          borderBottom: `1px solid ${ColorPallet.borderColor}`,
                          borderLeft:
                            colIndex === 0
                              ? `1px solid ${ColorPallet.borderColor}`
                              : removeBorder
                              ? "none"
                              : `1px solid ${ColorPallet.borderColor}`,
                          borderRight:
                            colIndex === headerData.length - 1
                              ? `1px solid ${ColorPallet.borderColor}`
                              : removeBorder
                              ? "none"
                              : `1px solid ${ColorPallet.borderColor}`,
                          width:
                            headerItem.title === "Name"
                              ? "300px"
                              : headerItem.title === "Dose"
                              ? "200px"
                              : headerItem.title === "Actions"
                              ? "100px"
                              : "auto",
                          "&.MuiTableCell-root": {
                            padding: "0px 0px 0px 15px !important",
                          },
                        }}
                      >
                        {row[headerItem.title]}
                      </TableCell>
                    );
                  })}
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {/* Fixed pagination with proper type handling */}

      {isPagination ? null : (
        <CustomPagination
          totalCount={totalCount}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={onPageChange}
          onRowsPerPageChange={onRowsPerPageChange}
        />
      )}
    </>
  );
};

export default AllTable;
